import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import { UploadScanStatus } from 'src/types';
import { getScanStatusColor } from 'src/utils';
import styled from 'styled-components';

export const UploadedEvidenceContainer = styled.div`
  width: 100%;
  padding: 20px;
`;

export const EvidenceTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)};
  font-weight: 600;
  padding-bottom: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding-bottom: 0;
  }
`;

export const TableHeadingRow = styled.tr`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  text-transform: uppercase;
  padding-bottom: 13px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const TableRow = styled.tr`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  padding-bottom: 13px;
  line-height: 30px;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const TableCell = styled.td`
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const TableFileNameCellLink = styled.a<{
  scanStatus?: UploadScanStatus | null;
}>`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => getScanStatusColor(props.scanStatus, props.theme)};
`;

export const FileNameText = styled.span<{
  scanStatus: UploadScanStatus | null;
}>`
  color: ${(props) => getScanStatusColor(props.scanStatus, props.theme)};
`;

export const FilesTable = styled.table`
  width: 100%;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-collapse: collapse;
    padding-left: 0;
  }
`;

export const FlaggedFilesError = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.destructive.default};
  padding-bottom: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const FlaggedFilesMobileError = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.atlas.semantic.color.action.destructive.default};
  display: none;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: block;
  }
`;

export const ResponsiveStyledIcon = styled(StyledIcon)`
  display: none;
  margin-right: 8px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: inline-block;
  }
`;

export const DeletedTableRow = styled(TableRow)`
  color: #666;
`;

export const FileNameContainer = styled.div`
  display: flex;
  align-items: center;
`;
